// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__vk0gZ","btn":"styles_btn__COSci"};